export const getTourExternalLink = (tourId: string) =>
  `${window.location.protocol}//${window.location.host}/playerext?tourId=${tourId}`;
